var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Question } from "./question";
import { QuestionType } from "app/shared/models/question-type";
var SingleChoiceQuestion = /** @class */ (function (_super) {
    __extends(SingleChoiceQuestion, _super);
    function SingleChoiceQuestion() {
        var _this = _super.call(this) || this;
        _this.type = QuestionType.SingleChoice;
        _this.isSelected = false;
        return _this;
    }
    Object.defineProperty(SingleChoiceQuestion.prototype, "answerDisplayText", {
        get: function () {
            if (this.isSelected == true) {
                return "Checked";
            }
            else {
                return "Not Checked";
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SingleChoiceQuestion.prototype, "answerForSave", {
        get: function () {
            return { isSelected: this.isSelected };
        },
        enumerable: true,
        configurable: true
    });
    SingleChoiceQuestion.prototype.setSavedAnswer = function (data, labels) {
        if (data && data.isSelected === true) {
            this.isSelected = true;
        }
        else {
            this.isSelected = false;
        }
    };
    SingleChoiceQuestion.prototype.hasAnswer = function (answer) {
        // it always has an answer if it's selected or not selected.
        return true;
    };
    Object.defineProperty(SingleChoiceQuestion.prototype, "isFilledOut", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    return SingleChoiceQuestion;
}(Question));
export { SingleChoiceQuestion };



// WEBPACK FOOTER //
// ./src/app/shared/models/single-choice-question.ts.pre-build-optimizer.js